<template>
  <div class="w-full">
    <!-- CW already transitioned away from Page Edit template. Now uses PostUpdate. -->
    <PageEdit v-if="client !== 'client1tenant'" :post_id="post_id" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageEdit from './PageEdit.vue'

export default {
  components: {
    PageEdit,
  },

  props: {
    post_id: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  computed: {
    ...mapGetters({
      client: 'shared/getClient',
    }),
  },

  watch: {
    post_id: {
      handler: function (id) {
        this.getPost(id)
      },

      deep: true,
    },
  },
}
</script>
